<div *ngIf="showAcademyRenewal" class="Plan-expire">
	<div class="media">
		<div class="media-left">
			<div class="icon">
				<img src="assets/img/coin/icon.png" alt="" />
			</div>
		</div>
		<div class="media-body" style="color: #fff!important;">
			<h4>Plan expires:</h4> Hey, you're academy affiliation has expired. Renew now to enjoy the affiliation benefits.
		</div>
		<div class="media-right">
			<button class="btn btn-primary" pButton (click)="onClickRenewal()"> Renew now </button>
		</div>
	</div>
</div>
<section class="payment-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12 payment-div">
				<div class="payment-heading">
					<h1>
						<div class="icon">
							<i class="bx bx-time"></i>
						</div> Payment History
					</h1>
				</div>
				<ul class="nav nav-pills mb-3 justify-content-center" id="pills-tab" role="tablist">
					<li class="nav-item" role="presentation">
						<button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
							data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
							aria-selected="true"> Membership History </button>
					</li>
					<li class="nav-item" role="presentation">
						<button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
							data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
							aria-selected="false"> Our Tournament </button>
					</li>
					<!-- <li class="nav-item" role="presentation">
						<button class="nav-link" id="pills-payment-tab" data-bs-toggle="pill"
							data-bs-target="#pills-payment" type="button" role="tab" aria-controls="pills-payment"
							aria-selected="false"> Withdrawals </button>
					</li> -->
				</ul>
				<div class="tab-content" id="pills-tabContent">
					<div class="tab-pane fade show active" id="pills-home" role="tabpanel"
						aria-labelledby="pills-home-tab" tabindex="0">
						<div class="col-md-12 transation-history">
							<div class="table-responsive">
								<p-table [value]="academyPaymentList" [paginator]="true" [rows]="10" [lazy]="true"
									[scrollable]="true" (onLazyLoad)="loadAcademyPayments($event)" pageLinks="3" [showPageLinks]="true"
									[resizableColumns]="true" [responsive]="true" [totalRecords]="totalRecords"
									[loading]="loading" class="table table-hover">
									<ng-template pTemplate="header">
										<tr>
											<th scope="col" style="flex: 0 0 235px">ID</th>
											<th scope="col">Membership</th>
											<th scope="col">Amount</th>
											<th scope="col">Transaction Date</th>
											<th scope="col">Expiry Date</th>
											<th scope="col">Status</th>
											<th scope="col">Action</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-list>
										<tr>
											<td scope="row" style="flex: 0 0 235px">{{ list.id }}</td>
											<td>
												<span style="text-transform: capitalize">{{ list.membershipType
													}}</span>
											</td>
											<td>
												<div class="dabit"> ₹ {{ list.amount / 100 }}
													<span></span>
												</div>
											</td>
											<td>{{ list.transactionDate | date : "mediumDate" }}</td>
											<td>{{ list.expiryDate | date : "mediumDate" }}</td>
											<td>
												<span *ngIf="list.status === 'pre_order'"
													style="color: green">Preorder</span>
												<span *ngIf="list.status === 'expire'"
													style="color: green">Expired</span>
												<span *ngIf=" list.status != 'pre_order' && list.status != 'expire'" style="color: green">{{ list.status | titlecase }}</span>
											</td>
											<td *ngIf="list.status != 'free'">
												<i *ngIf="(list.status === 'paid' || list.status === 'expire' || list.status === 'pre_order') && list.invoiceFile" class="bx bxs-file-pdf" style="color: red; font-size: 18px" (click)="downloadPdf(list.invoiceFile)"></i>
												<button *ngIf="list.status === 'created' || (!list.invoiceFile && list.membershipType !== 'free')" pButton
													pRipple label="Pay Now" (click)="sendToPay(list.orderId)"></button>
											</td>
											<td *ngIf="list.status === 'free'">
												<i *ngIf="list.invoiceFile" class="bx bxs-file-pdf" style="color: red; font-size: 18px" (click)="downloadPdf(list.invoiceFile)"></i>
											</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
						tabindex="0">
						<div class="col-md-12 transation-history transation-history-tournament">
							<div class="table-responsive">
								<p-toolbar styleClass="p-mb-4 col-md-12">
									<div class="card w-100 top-date-range">
										<div class="forms-date-filter ">
											<div class="p-field p-col-auto">
												<label for="startdt">Start Date</label>
												<p-calendar monthNavigator="true" yearNavigator="true" appendTo="body"
													yearRange="2022:2050" [(ngModel)]="startDateTournament"
													class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
													[showIcon]="true"></p-calendar>
											</div>
											<div class="p-field p-col-auto">
												<label for="enddt">End Date</label>
												<p-calendar monthNavigator="true" yearNavigator="true" appendTo="body"
													yearRange="2022:2050" [(ngModel)]="endDateTournament"
													class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
													[showIcon]="true"></p-calendar>
											</div>
											<div class="p-field p-col-auto search-btn">
												<button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-"
													(click)="tournamentIncomeHistory($event)"></button>
											</div>
										</div>
										<div class="p-field p-col-auto p-mb-0">
											<button pButton label="Clear Filters"
												class="p-button-outlined p-mr-0 p-mb-0" icon="pi pi-filter-slash"
												pTooltip="Clear Filters" tooltipPosition="bottom"
												(click)="clear()"></button>
										</div>
									</div>
								</p-toolbar>
								<div class="mobile-filter">
									<div class="p-field p-col-auto search-btn">
										<button pButton label="Filters" class="p-button-outlined p-mr-0 p-mb-0"
											icon="pi pi-filter" pTooltip="Filters" tooltipPosition="bottom"
											(click)="showFilter()"></button>
									</div>
								</div>
								<p-table [value]="tournamentData" dataKey="name" responsiveLayout="scroll" pageLinks="3" [showPageLinks]="true"
									rowExpandMode="single" class="maincategory-table" [paginator]="true" [rows]="10"
									[lazy]="true" [scrollable]="true" (onLazyLoad)="tournamentIncomeHistory($event)"
									[resizableColumns]="true" [responsive]="true" [totalRecords]="totalCount"
									[loading]="loading">
									<ng-template pTemplate="header">
										<tr class="top-row-tr table-head-top">
											<th style="width: 1rem"></th>
											<th>Tournament Name</th>
											<th>Location</th>
											<th>Categories</th>
											<th> Start Date</th>
											<th> End Date</th>
											<th>Participants</th>
											<th>Total Amount</th>
											<!-- <th>Action</th> -->
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-data let-expanded="expanded">
										<tr [ngClass]="{'active-row': this.expanded}" class="top-row-tr">
											<td>
												<button type="button" pButton pRipple [pRowToggler]="data"
													class="p-button-text p-button-rounded p-button-plain"
													(click)="getTournamentCategory(data._id)"
													[icon]=" expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right' "></button>
											</td>
											<td>
												<h4 class="main-category-name" pTooltip="{{ data.name }}"
													tooltipPosition="bottom">{{ data.name }}
												</h4>
											</td>
											<td>{{ data.cityname }}</td>
											<td>{{ data.resultCat.length }}</td>
											<td>{{ data.startdate | date : "dd/MM/yyyy" }}</td>
											<td>{{ data.enddate | date : "dd/MM/yyyy" }}</td>
											<td>{{ data.result.length }}</td>
											<td>{{ data.total | currency : "INR" }}</td>
											<!-- <td>
												<button *ngIf="!kycDone" class="updateKYC" routerLink="/kyc-update"
													pTooltip="To transfer money to your bank, you must first update your KYC."><span><i
															class='bx bx-file-find'></i></span> Update KYC </button>
												<button *ngIf="kycDone && !kycApprove" [disabled]="kycApprove"
													class="transfer-amount disabled kyc-not-approve"
													pTooltip="KYC Not Approve."><span><i
															class='bx bx-transfer'></i></span> Withdraw </button>
												<button
													*ngIf="data.isCompleted && kycDone && kycApprove && data.isTournamentEnd"
													[disabled]="data.isClaim" class="transfer-amount"
													(click)="onClickWithdraw(data)"><span><i
															class='bx bx-transfer'></i></span> Withdraw </button>
											</td> -->
										</tr>
									</ng-template>
									<ng-template pTemplate="rowexpansion" let-data>
										<tr class="expanded-row d-block">
											<!--Desk Top Version alert --->
											<td colspan="9" class="desktop-verison-alert">
												<div class="row select-category w-100 justify-content-between">
													<div class="withdraw-button-div">
														<!-- <p-button label="Withdraw Money" icon="bx bxs-wallet-alt" iconPos="right"  (click)="showWithdrawDialog()"></p-button> -->
													</div>
													<div class="col-md-auto p-pr-0">
														<div class="drop-down-div">
															<label for="categoryType">Select Category: </label>
															<p-dropdown [style]="{ width: '180px' }"
																inputId="categoryType" appendTo="body"
																[options]="categoryList" [filter]="true"
																placeholder="Select Category"
																optionLabel="matchTypeName" [ngClass]="{
										  'is-invalid': submitted && f.categoryType.errors
										}" (onChange)="onSelectCategory($event, data._id)"></p-dropdown>
															<div *ngIf="
										  submitted && f.categoryType.errors.required
										" class="invalid-feedback"> Please select Match type </div>
														</div>
														<div class="drop-down-div">
															<label for="ageGroup">Select Age Group: </label>
															<p-dropdown [style]="{ width: '180px' }" inputId="ageGroup"
																appendTo="body" [options]="ageGroupList" [filter]="true"
																placeholder="Select Age Group"
																optionLabel="ageGroupName" [ngClass]="{
										  'is-invalid': submitted && f.ageGroup.errors
										}" (onChange)="onAgeGroupSelect($event, data._id)"></p-dropdown>
															<div *ngIf="submitted && f.ageGroup.errors.required"
																class="invalid-feedback"> Please select Age Group </div>
														</div>

													</div>

												</div>
											</td>
											<!--Desk Top Version alert close--->
										</tr>
										<tr class="expanded-row d-block">
											<td colspan="9" class="desktop-verison-alert">
												<div class="p-p-3 w-100">
													<p-table [value]="playerdata" dataKey="id" pageLinks="3" [showPageLinks]="true"
														class="expanded-inner-table">
														<ng-template pTemplate="header">
										<tr style="    background-color: #20b033 !important;
										box-shadow: 0px 0px 15px #0000003b inset;
										color: #fff !important;">
											<th>Transaction ID</th>
											<th>Name</th>
											<!-- <th>Date</th> -->
											<th>Fees</th>
											<th>Status</th>
											<!-- <th >Action</th> -->
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-playerdata>
										<tr>
											<td>
												{{ playerdata.playerDetails[0]["_id"] }}
											</td>
											<td>
												{{ playerdata.playerDetails[0]["fullName"] }}
											</td>
											<td>
												{{ playerdata.entryFee | currency : "INR" }}
											</td>
											<td>
												<span style="color: green">Paid</span>
											</td>
											<!-- <td><p-button type="button" icon="pi-ellipsis-v"></p-button></td> -->
										</tr>
									</ng-template>
									<ng-template pTemplate="summary" let-playerdata>
										<div class="p-d-flex p-ai-center p-jc-between" *ngIf="!playerRegister">
											<div class="not-found-section">
												<div class="col-md-12 not-found-body">
													<img src="assets/img/logo/not-found.gif" alt="">
													<h4> The player has not registered for this category.</h4>
													<p>Please check other categories and age groups.</p>
												</div>
											</div>
										</div>
										<div class="p-d-flex p-ai-center p-jc-between" *ngIf="showDefault">
											<div class="not-found-section">
												<div class="col-md-12 not-found-body">
													<img src="assets/img/logo/not-found.gif" alt="">
													<h4>Please Select Categories and Age Group</h4>
												</div>
											</div>
										</div>
									</ng-template>
								</p-table>
							</div>
							</td>
							</tr>
							</ng-template>
							</p-table>
							<!--Mobile version-->
							<p-table [value]="tournamentData" dataKey="name" responsiveLayout="scroll" pageLinks="3" [showPageLinks]="true"
								rowExpandMode="single" class="maincategory-table mobileversion-table-category"
								[paginator]="true" [rows]="10" [lazy]="true" [scrollable]="true"
								(onLazyLoad)="tournamentIncomeHistory($event)" [resizableColumns]="true" [responsive]="true"
								[totalRecords]="totalCount" [loading]="loading">
								<ng-template pTemplate="header">
									<tr class="top-row-tr table-head-top">
										<th style="width: 1rem"></th>
										<th>Tournament Name</th>
										<th>Location</th>
										<th>Categories</th>
										<th> Start Date</th>
										<th> End Date</th>
										<th>Total Participants</th>
										<th>Total Amount</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-data let-expanded="expanded">
									<tr [ngClass]="{'active-row': this.expanded}" class="top-row-tr">
										<td>
											<button type="button" pButton pRipple [pRowToggler]="data"
												class="p-button-text p-button-rounded p-button-plain"
												(click)="getTournamentCategory(data._id)"
												[icon]=" expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right' "></button>
										</td>
										<td>
											<h4 class="main-category-name" pTooltip="{{ data.name }}"
												tooltipPosition="bottom">{{ data.name }}
											</h4>
										</td>
										<td>{{ data.cityname }}</td>
										<td>{{ data.resultCat.length }}</td>
										<td>{{ data.startdate | date : "dd/MM/yyyy" }}</td>
										<td>{{ data.enddate | date : "dd/MM/yyyy" }}</td>
										<td>{{ data.result.length }}</td>
										<td>{{ data.total | currency : "INR" }}</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="rowexpansion" let-data class="mobileversion-result">
									<tr class="expanded-row d-block mobile-details">
										<td class="test-t">
									<tr class="expanded-row d-block w-100">
										<!--Desk Top Version alert --->
										<td class="desktop-verison-alert">
											<div class="header">
												<div class="title">
													{{ data.name }}
												</div>
												<div class="close-btn">
													<button type="button" pButton pRipple [pRowToggler]="data"
														class="p-button-text p-button-rounded p-button-plain"
														(click)="getTournamentCategory(data._id)"
														[icon]=" expanded ? 'pi pi-times' : 'pi pi-times' "></button>
												</div>
											</div>
										</td>
										<!--Desk Top Version alert close--->
									</tr>
									<tr class="expanded-row d-block w-100 details-popup">
										<td class="filter-td-mobile">
											<div class="row select-category w-100">
												<div class="col-md-auto">
													<label for="categoryType">Select Category: </label>
													<p-dropdown [style]="{ width: '180px' }" inputId="categoryType"
														appendTo="body" [options]="categoryList" [filter]="true"
														placeholder="Select Category" optionLabel="matchTypeName"
														[ngClass]="{
									'is-invalid': submitted && f.categoryType.errors
								  }" (onChange)="onSelectCategory($event, data._id)"></p-dropdown>
													<div *ngIf="
									submitted && f.categoryType.errors.required
								  " class="invalid-feedback"> Please select Match type </div>
												</div>
												<div class="col-md-auto">
													<label for="ageGroup">Select Age Group: </label>
													<p-dropdown [style]="{ width: '180px' }" inputId="ageGroup"
														appendTo=".mobile-details" appendTo="body"
														[options]="ageGroupList" [filter]="true"
														placeholder="Select Age Group" optionLabel="ageGroupName"
														[ngClass]="{
									'is-invalid': submitted && f.ageGroup.errors
								  }" (onChange)="onAgeGroupSelect($event, data._id)"></p-dropdown>
													<div *ngIf="submitted && f.ageGroup.errors.required"
														class="invalid-feedback"> Please select Age Group </div>
												</div>
											</div>
										</td>
										<td class="desktop-verison-alert">
											<div class="p-p-3 w-100 mobile-main-table">
												<p-table [value]="playerdata" pageLinks="3" [showPageLinks]="true" dataKey="id" class="expanded-inner-table">
													<ng-template pTemplate="header">
									<tr>
										<th style="display: block!important;">Name </th>
										<th style="display: block!important;">Fees</th>
										<!-- <th style="display: block!important;">Date</th> -->
										<th style="display: block!important;">Status</th>
										<th style="display: none!important;">Status</th>
										<!-- <th >Action</th> -->
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-playerdata>
									<tr>
										<td>
											{{ playerdata.playerDetails[0]["fullName"] }}
										</td>
										<td>
											{{ playerdata.entryFee | currency : "INR" }}
										</td>
										<td>
											<span style="color: green; font-size: 14px;">Paid</span>
										</td>
										<td></td>
										<!-- <td><p-button type="button" icon="pi-ellipsis-v"></p-button></td> -->
									</tr>
									<tr>
										<td colspan="4" style="    display: flex!important;
										  flex: 0 0 100%!important;
										  padding-top: 0px!important;    justify-content: flex-start;
	  gap: 5px;">
											<b style="    font-size: 13px;">Transaction ID:</b> {{
											playerdata.playerDetails[0]["_id"] }}
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="summary" let-playerdata>
									<div class="p-d-flex p-ai-center p-jc-between" *ngIf="!playerRegister">
										<div class="not-found-section">
											<div class="col-md-12 not-found-body">
												<img src="assets/img/logo/not-found.gif" alt="">
												<h4> The player has not registered for this category.</h4>
												<p>Please check other categories and age groups.</p>
											</div>
										</div>
									</div>
									<div class="p-d-flex p-ai-center p-jc-between" *ngIf="showDefault">
										<div class="not-found-section">
											<div class="col-md-12 not-found-body">
												<img src="assets/img/logo/not-found.gif" alt="">
												<h4>Please Select Categories and Age Group</h4>
											</div>
										</div>
									</div>
								</ng-template>
							</p-table>
						</div>
						</td>
						</tr>
						</td>
						</tr>
						</ng-template>

						</p-table>
						<!--Mobile version Close-->
					</div>
				</div>
			</div>
			<!-- <div class="tab-pane fade" id="pills-payment" role="tabpanel" aria-labelledby="pills-profile-tab"
				tabindex="0">
				<div class="col-md-12 transation-history transation-history-tournament">
					<p-table #dt [value]="withdrawList" [paginator]="true" [rows]="10" [lazy]="true" appendTo=""
						[autoLayout]="true" (onLazyLoad)="loadWallet($event)" [totalRecords]="totalWithdrawRecords"
						[loading]="loading" [rowsPerPageOptions]="paginationOption">
						<ng-template pTemplate="header">
							<tr>
								<th style="display: table-cell!important;" pSortableColumn="id" class="transactionId">
									Tournament Name</th>
								<th pSortableColumn="created_at" class="">
									<div class="p-d-flex p-jc-between p-ai-center"> Date
									</div>
								</th>
								<th class="" pSortableColumn="transferAmount">
									<div class="p-d-flex p-jc-between p-ai-center"> Amount
									</div>
								</th> -->
								<!-- <th class="" pSortableColumn="tds">
									<div class="p-d-flex p-jc-between p-ai-center"> TDS
									</div>
								</th> -->
								<!-- <th class="" pSortableColumn="commission">
									<div class="p-d-flex p-jc-between p-ai-center"> Commission
									</div>
								</th>
								<th class="" pSortableColumn="totalCreditedAmount">
									<div class="p-d-flex p-jc-between p-ai-center"> Transferable Amount
									</div>
								</th>
								<th pSortableColumn="status" class="statusTd">
									<div class="p-d-flex p-jc-between p-ai-center"> Status
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-data>
							<tr class="p-selectable-row">
								<td class="transactionId">
									{{ data.tournament}}
								</td>
								<td class="transactiodescription">
									{{ data.created_at | date : "MM/dd/yyyy" }}
								</td>
								<td class="date">
									{{ data.transferAmount | currency : "INR" }}
								</td> -->
								<!-- <td>
									{{ data.tds | currency : "INR" }}
								</td> -->
								<!-- <td>
									{{ data.commission | currency : "INR" }}

								</td>
								<td>
									{{ data.totalCreditedAmount | currency : "INR" }}
								</td>
								<td>
									{{ data.status  }}
								</td>
				
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div> -->
		</div>
	</div>
	</div>
	</div>
</section>
<p-dialog header="Header" [(visible)]="filtervisible" [modal]="true" [style]="{ width: 'calc(100% - 30px)' }"
	id="filter-popup">
	<ng-template pTemplate="header">
		<span class="text-xl font-bold">Header Content</span>
	</ng-template>
	<p-toolbar styleClass="p-mb-0 p-mt-3 col-md-12">
		<div class=" w-100 top-date-range p-p-0">
			<div class="forms-date-filter ">
				<div class="p-field p-col-auto">
					<label for="startdt">Start Date</label>
					<p-calendar monthNavigator="true" yearNavigator="true" appendTo="body" yearRange="2022:2050"
						[(ngModel)]="startDateTournament" class="p-calendar w-100" inputId="calendar"
						dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
				</div>
				<div class="p-field p-col-auto">
					<label for="enddt">End Date</label>
					<p-calendar monthNavigator="true" yearNavigator="true" appendTo="body" yearRange="2022:2050"
						[(ngModel)]="endDateTournament" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
						[showIcon]="true"></p-calendar>
				</div>
			</div>
		</div>
	</p-toolbar>
	<ng-template pTemplate="footer">
		<div class="p-field p-col-12 search-btn">
			<button pButton label="Clear Filters" class="p-button-outlined p-mr-0 p-mb-0" icon="pi pi-filter-slash"
				pTooltip="Clear Filters" tooltipPosition="bottom" (click)="clear()"></button>
			<button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="tournamentIncomeHistory()"
				(click)="filtervisible = false"></button>
		</div>
	</ng-template>
</p-dialog>
<p-dialog header="Choose Your Plan" [(visible)]="showPlanModal" modal="modal" showEffect="fade"
	[style]="{ width: '500px' }" (onHide)="onClickResetPlan()" class="select-plane" id="expire-modals">
	<div id="renew-modal" class="modal-dialog" style="width: 100% !important; padding: 0px !important">
		<div class="modal-content" style="border: none; padding: 0px">
		
			<div *ngIf="selectedMembershipType"> 
				<div class="lbl-custom heading-div"> 
					<div class="table-price">
						<table>
					 
							<tbody>
								<thead>
									<tr>
										<th>Benefits</th>
										<td   [ngClass]="{'active': isActive('premium')}">Premium</td>
										<td  [ngClass]="{'active': isActive('standard')}">Standard</td> 
									</tr>
								</thead>
								<tr class="main-pricing-table">
									<th>
										<ul>
											<li>Balls (in Dozens)</li>
											<li>Jerseys</li>
											<li>Discount On Balls</li>
											<li>Tournament Points</li>
											<li>Certificates</li>
											<li>TPL Auction Invite</li>
											<li>TPL League Invite</li>
											<li>Listing Priority</li>
											<li>Digital Promotions</li>
											<li>RTG Initiative</li>
											<li>Referral Code Bonus</li>
											<!-- <li>Trophies</li> -->
											
										</ul>
									</th>
									<td [ngClass]="{'active': isActive('premium')}">
										<ul>
											<li>24 (Platinum)</li>
											<li>4</li>
											<li><img src="../../../../assets/img/acadmy/Vector.svg"
												alt=""></li>
											<li>500 Pts</li>
											<li>Digital</li>
											<li>1 Pass</li>
											<li>
												2 VIP Passes
											</li> 
											<li>High</li>
											<!-- <li>High</li> -->
											<li>
												<img src="../../../../assets/img/acadmy/Vector.svg" alt="">
											</li>
											<li>
												<img src="../../../../assets/img/acadmy/Vector.svg" alt="">
											</li>
											<li>
												<img src="../../../../assets/img/acadmy/Vector.svg" alt="">
											</li> 
										</ul>
									</td>
									<td [ngClass]="{'active': isActive('standard')}" class="free-td">
										<ul>
											<li>12 (Championship)</li>
											<li>2</li>
											<li><img src="../../../../assets/img/acadmy/Vector.svg" alt=""></li>
											<li>250 Pts</li>
											<li>
												Digital
											</li>
											<!-- <li>Digital</li> -->
											<li>
												<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
													<circle cx="9" cy="9" r="9" fill="#1B8D2A"/>
													<path d="M10.8157 12L8.92566 9.399L7.06266 12H6.02766L8.39466 8.769L6.17166 5.7H7.19766L8.96166 8.121L10.7077 5.7H11.6887L9.46566 8.742L11.8507 12H10.8157Z" fill="white"/>
													</svg>
													
											</li>
											<li>2 General Passes</li>
											<li>Medium</li>
											<li>
												<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
													<circle cx="9" cy="9" r="9" fill="#1B8D2A"/>
													<path d="M10.8157 12L8.92566 9.399L7.06266 12H6.02766L8.39466 8.769L6.17166 5.7H7.19766L8.96166 8.121L10.7077 5.7H11.6887L9.46566 8.742L11.8507 12H10.8157Z" fill="white"/>
													</svg>
											</li>
											<li>
												<img src="../../../../assets/img/acadmy/Vector.svg" alt="">
											</li>
											<li>
												<img src="../../../../assets/img/acadmy/Vector.svg" alt="">
											</li>
										</ul>
									</td> 
								</tr> 
							</tbody>
						</table>
					</div>  
				</div>
			</div>
			<div class="modal-body">
				
				<ul>
					<li *ngFor="let membership of membershipTypeList" class="Premium-list" [ngClass]="
				  selectedMembershipType == membership.value ? 'active' : '' ">
						<div (click)="onClickPlan(membership)" class="tems-image">
							<div class="price-box">
								<i *ngIf="membership.selected" class="pi pi-check"></i>
								<span style="text-transform: capitalize" class="packageName"> {{ membership.value }} </span>
								<span class="price-div">{{membership.currency }} {{ membership.amount }}</span>
								<span class="priceMonth">
									<span *ngIf="membership.value == 'premium'">{{membership.duration }} Months</span>
									<!-- <span *ngIf="membership.value == 'standard'">{{ membership.duration }} Months</span> -->
									<span *ngIf="membership.value == 'standard'">{{membership.duration }} Months</span>
								</span>
							</div>
							<span *ngIf="membership.value == 'premium'" class="recomanded"> (Recommended) </span>
						</div>
					</li>
				</ul>
			
				
				<div *ngIf="showError">
					<span>Please select membership type. </span>
				</div>
			</div>
		</div>
	</div>
	<p-footer>
		<div class="modal-footer justify-content-center">
			<button type="button" class="btn btn-primary" (click)="onClickPayNow()"> Pay Now </button>
		</div>
	</p-footer>
</p-dialog>


<p-dialog header="Withdraw Money" [(visible)]="Withdrawmoney" [modal]="true" [style]="{ width: '500px' }"
	[draggable]="false" [resizable]="false" class="thank-popup-div">
	<div class="confirm-div col-md-12">
		<img src="assets/img/players/output-onlinegiftools.gif" alt="">
		<h2>Thank You!</h2>
		<p>the successful transfer of your funds into your wallet. </p>
	</div>



	<ng-template pTemplate="footer">
		<p-button label="Go To Wallet" styleClass="p-button-text" routerLink="/wallet"></p-button>
	</ng-template>
</p-dialog>